<template lang="pug">
.neutral200
  v-row(no-gutters)
    v-col.py-2.pr-2
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total sales (All campaigns)
        div.d-flex.mt-4.mb-1(v-if="isFetchingMeta")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ meta.total_sales | displayPrice($currency) }}
    v-col.py-2.px-2
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Active campaigns
        div.d-flex.mt-4.mb-1(v-if="isFetchingMeta")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ meta.active_campaigns | displayNumber }}
    v-col.py-2.pl-2
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Sales opportunities

        div.d-flex.align-center
          v-progress-circular.mt-4.mb-1(v-if="isFetchingMeta" :width="3" :size="28" color="neutral500" indeterminate)
          div.text-g5.mt-4(v-else) {{ meta.opportunities | displayNumber }}
          v-spacer
          y-button.mt-4(label="Go now" underline color="neutral700" size="xs" button-class="px-0" append-icon="mdi-chevron-right" icon-color="neutral700" icon-size="20" @click="showOpportunitiesDialog = true")
  
  v-card.border.rounded-lg.pa-6.mt-2(outlined)
    v-row.pb-2.pb-md-0(no-gutters)
      v-col(cols="12" md="8")
        v-tabs(v-model="tabs" color="basic700" :height="44" grow active-class="font-semibold" @change="tabChanged(tabs)")
          v-tab.text-sm.font-medium.text-none.px-0 {{ $t('all') }}
          v-tab.text-sm.font-medium.text-none.px-0 Scheduled
          v-tab.text-sm.font-medium.text-none.px-0 Active
          v-tab.text-sm.font-medium.text-none.px-0 Draft
          v-tab.text-sm.font-medium.text-none.px-0 Completed
          v-tab.text-sm.font-medium.text-none.px-0 Archived
      v-col(cols="12" md="4" align="end")
        .d-flex.align-center
          v-spacer
          v-btn(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          div(v-if="!showSearchField")
            customize-column-menu(type="offer" :showTooltip="false" iconSize="21")
          y-button.ml-3(label="Create new" size="sm" button-class="px-3" @click="createNewOffer")
    v-divider

    .data-table
      v-data-table.mt-sm-4.pb-6(:headers="headers" :items="offers" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="viewOfferDetails")
        //- Campaign
        template(v-slot:item.name="{ item }")
          div.d-flex.align-center.my-2
            v-avatar.mr-2(size="8" :color="getColor(item)")
            div.text-sm.font-semibold.neutral700--text.underline {{ item.name }}
        //- Active period
        template(v-slot:item.active_period="{ item }")
          div.my-2(v-if="item.end_at")
            div.text-sm.neutral700--text {{ item.start_at | humanizeDate }} -
            div.text-sm.neutral700--text {{ item.end_at | humanizeDate }}
          div.text-sm.neutral700--text.my-2(v-else) No period limit
        //- Customers
        template(v-slot:item.total_audiences="{ item }")
          div.text-sm.neutral700--text.my-2 {{ item.total_audiences }}
        //- Redeemed
        template(v-slot:item.redeemed="{ item }")
          div.text-sm.neutral700--text.my-2 {{ item.total_redeemed }}/{{ item.usage_limit_type === 'quantity' ? item.usage_limit : item.total_coupons }}
        //- Conversion
        template(v-slot:item.conversion="{ item }")
          div.text-sm.neutral700--text.my-2(v-if="(item.usage_limit_type === 'quantity' && item.usage_limit) || item.total_audiences") {{ Math.floor(Number(item.total_redeemed * 100) / (item.usage_limit_type === 'quantity' ? Number(item.usage_limit) : Number(item.total_audiences))) }}%
          div.text-sm.neutral700--text.my-2(v-else) -
        //- Status
        template(v-slot:item.status="{ item }")
          y-chip(v-if="item.has_paused_blast && item.status !== 'archived'" label="Paused" color="grey")
          template(v-else)
            y-chip(v-if="item.status === 'active'" label="Active" color="green")
            y-chip(v-if="item.status === 'scheduled'" label="Scheduled" color="normal")
            y-chip(v-if="item.status === 'draft'" label="Draft" color="orange")
            y-chip(v-if="item.status === 'completed'" label="Completed" color="blue")
            y-chip(v-if="item.status === 'archived'" label="Archived" color="red")
        //- Actions
        template(v-slot:item.actions="{ item, index }")
          div(align="center" v-if="item.status !== 'archived'" @click.stop)
            y-button(v-if="item.type === 'preset'" label="Edit" size="xs" outlined @click="viewOfferDetails(item)")
            v-menu(v-else offset-y :top="menuPositionTop(index)" left attach rounded="lg")
              template(#activator="{ on }")
                v-btn(icon small v-on="on")
                  v-icon mdi-dots-horizontal
              v-list.py-0(align="start")
                v-list-item(@click="viewOfferDetails(item)")
                  v-list-item-title.text-sm.basic800--text View details
                v-divider
                v-list-item(@click="openDuplicateDialog(item)")
                  v-list-item-title.text-sm.basic800--text Duplicate
                v-divider
                v-list-item(@click="archiveOffer(item)")
                  v-list-item-title.text-sm(:class="item.status !== 'archived' ? 'danger500--text' : 'success500--text'") {{ item.status !== 'archived' ? 'Archive' : 'Activate' }}

    div.d-flex.align-center(v-if="totalCount > pageSize")
      v-spacer
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    opportunities-dialog(v-if="showOpportunitiesDialog" :open.sync="showOpportunitiesDialog" @selected="selectOpportunity($event)")
    create-opportunity-offer-dialog(v-if="showCreateOpportunityOfferDialog" :open.sync="showCreateOpportunityOfferDialog" :opportunity="selectedOpportunity" @closed="closed" @updated="fetchFirstPage")
    duplicate-campaign-dialog(v-if="showDuplicateDialog" :open.sync="showDuplicateDialog" :offer="selectedOffer" @closed="closed" @updated="fetchFirstPage")
    delete-confirmation-dialog(v-if="openArchiveDialog" :open.sync="openArchiveDialog" :loading="isLoading" @cancel="closed" @delete="confirmArchive")
      .text-lg.font-medium Are you sure you want to archive this offer?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import OpportunitiesDialog from '@/components/clinic/marketing/dialogs/OpportunitiesDialog.vue'
import CreateOpportunityOfferDialog from '@/components/clinic/marketing/dialogs/CreateOpportunityOfferDialog.vue'
import DuplicateCampaignDialog from '@/components/clinic/marketing/dialogs/DuplicateCampaignDialog.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: { CustomizeColumnMenu, OpportunitiesDialog, CreateOpportunityOfferDialog, DuplicateCampaignDialog, DeleteConfirmationDialog },
  data: () => ({
    isFetching: false,
    isFetchingMeta:false,
    isLoading: false,
    showSearchField: false,
    showDuplicateDialog: false,
    showOpportunitiesDialog: false,
    showCreateOpportunityOfferDialog: false,
    openArchiveDialog: false,
    searchText: null,
    selectedOffer: null,
    selectedOpportunity: null,
    pageSize: 20,
    totalCount: 0,
    offers: [],
    meta: {},
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      offerFields: 'clinic/getOfferFields',
      storedTabs: 'marketing/getOffersTabs',
      storedPage: 'marketing/getOffersPage',
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Campaign', value: 'name', enable: true, class: 'text-table-header' }
      const fields = this.offerFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item.class = 'text-table-header'
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false,
        class: 'text-table-header'
      }
      return [name, ...fields, actions]
    },
    tabs: {
      get () { return this.storedTabs },
      set (val) { this.$store.commit('marketing/setOffersTabs', val) }
    },
    currentPage: {
      get () { return this.storedPage },
      set (val) { this.$store.commit('marketing/setOffersPage', val) }
    },
  },
  mounted () {
    this.isFetchingMeta = true
    this.fetchOfferList()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOfferList () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
        types: 'campaign,preset'
      }
      if (this.tabs === 1) { params.status = 'scheduled' }
      if (this.tabs === 2) { params.status = 'active' }
      if (this.tabs === 3) { params.status = 'draft' }
      if (this.tabs === 4) { params.status = 'completed' }
      if (this.tabs === 5) { params.status = 'archived' }
      if (this.searchText) { params.search = this.searchText }
      this.$axios.get(`/marketing/${this.company.slug}/offers`, { params })
        .then(resp => {
          this.offers = resp.data.results
          this.totalCount = resp.data.count
          this.meta = resp.data.meta
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
        })
        .finally(() => {
          this.isFetching = false
          this.isFetchingMeta = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchOfferList()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchOfferList()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    createNewOffer () {
      this.$router.push(`/admin/clinic/marketing/offer/create`)
    },
    viewOfferDetails (item) {
      if (item.status === 'archived') {
        return
      }
      if (item.type === 'preset') {
        this.$router.push(`/admin/clinic/marketing/offer/preset/${item.id}`)
        return
      }
      if (item.status === 'draft') {
        this.$router.push(`/admin/clinic/marketing/offer/create/${item.id}`)
        return
      }
      this.$router.push(`/admin/clinic/marketing/offer/${item.id}`)
    },
    getColor (item) {
      if (item.status === 'active') return 'success500'
      if (item.status === 'scheduled') return 'neutral400'
      if (item.status === 'draft') return 'yellow500'
      if (item.status === 'completed') return 'blue500'
      if (item.status === 'archived') return 'danger500'
    },
    openDuplicateDialog (item) {
      this.selectedOffer = item
      this.showDuplicateDialog = true
    },
    confirmArchive () {
      this.isFetching = true
      let data = { status: 'archived' }
      this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.selectedOffer.id}`, data)
        .then(() => {
          this.reset()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    archiveOffer (item) {
      this.selectedOffer = item
      this.openArchiveDialog = true
    },
    selectOpportunity (opportunity) {
      this.selectedOpportunity = opportunity
      this.showCreateOpportunityOfferDialog = true
      this.showOpportunitiesDialog = false
    },
    reset () {
      this.fetchFirstPage()
      this.closed()
    },
    closed () {
      this.selectedOffer = null
      this.selectedOpportunity = null
      this.openArchiveDialog = false
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.offers.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>